import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useMetadataContext } from './Context'

export type MaximizeButtonProps = { className?: string }

/**
 * Toggle for the Specifications full-screen grid.
 *
 * Renders a bordered `BusyButton` whose icon and label flip with the maximized state —
 * `window-maximize` / `Maximize specifications` when inline, `window-restore` /
 * `Restore specifications` when the modal is open. The visible label is the accessible
 * name; the tooltip mirrors it.
 *
 * Renders nothing when the viewer lacks the edit permission, or when the tree mounts
 * compact — the popover toolbar has no room for it.
 */
export const MaximizeButton = ({ className }: MaximizeButtonProps) => {
  const { isMaximized, toggleMaximized, hasRole, compact } = useMetadataContext()

  if (!hasRole || compact) return null

  const label = isMaximized ? 'Restore specifications' : 'Maximize specifications'
  const iconName = isMaximized ? 'window-restore' : 'window-maximize'

  return <BusyButton icon={iconName} onClick={toggleMaximized} text={label} title={label} className={className} />
}
